import { Controller } from "@hotwired/stimulus"
import { typeformFiles } from "../wizard/typeform_files"
import { typeformAirlineProgramme } from "../wizard/typeform_airline_programme"
import { typeformNavigation } from "../wizard/typeform_navigation"
import { typeformReview } from "../wizard/typeform_review"
import { typeformValidation } from "../wizard/typeform_validation"
import { typeformValidationMethod } from "../wizard/typeform_validation_method"

class TypeformController extends Controller {
  static targets = [
    "step",
    "progress",
    "progressTab",
    "backButton",
    "supportingDocumentsInput",
    "validationUploadHint",
    "uploadDropzoneLabel",
    "uploadSelectedPanel",
    "uploadSelectedHeading",
    "uploadFlow",
    "fileList",
    "reviewStep",
    "reviewSubmit",
    "journeyCard",
    "screenShareFlow",
    "wizardForm"
  ]

  static values = {
    current: { type: Number, default: 0 },
    criteria: { type: Object, default: {} },
    defaultOriginProgramme: { type: String, default: "" },
    defaultOriginTier: { type: String, default: "" },
    airlineProgrammeMatchUrl: String,
    i18n: { type: Object, default: {} }
  }

  connect() {
    this.totalSteps = this.stepTargets.length
    this.filePreviewUrls = []
    this.showStep(this.currentValue)
    this.updateValidationMethodUI()
    this.syncUploadStepVisibility()
    this.updateWizardStepper()
    this.syncReviewSubmitEnabled()
    this.syncReviewSummaryFromForm()
    this.bindKeyboard = this.handleKeyboard.bind(this)
    document.addEventListener("keydown", this.bindKeyboard)
  }

  disconnect() {
    document.removeEventListener("keydown", this.bindKeyboard)
    this.revokeFilePreviewUrls()
  }
}

Object.assign(
  TypeformController.prototype,
  typeformNavigation,
  typeformReview,
  typeformValidation,
  typeformAirlineProgramme,
  typeformFiles,
  typeformValidationMethod
)

export default TypeformController
